/**
 * CLICKAR.BIZ INTERNATIONAL REST API
 * APIs Clickar.biz international.
 *
 * OpenAPI spec version: API V1
 * Contact: blureply@reply.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, Optional } from "@angular/core";

import { environment } from "@app/../environments/environment";
import { HeaderKey } from "@shared/clickar-constants";
import { FeedbackDTO } from "@shared/model/auctioneer.model";
import { MyLotFullDTO, ShowcaseDTO, ShowcaseFullDTO } from "@shared/model/showcase.model";
import { VehicleShowcaseDTO } from "@shared/model/vehicle.model";
import { Configuration } from "@shared/services/utils/configuration";
import { CustomHttpUrlEncodingCodec } from "@shared/services/utils/encoder";
import { Observable } from "rxjs";


@Injectable()
export class ShowcaseService {
	private basePath = environment.baseApiUrl;
	defaultHeaders = new HttpHeaders();
	configuration = new Configuration();
	readonly encoderParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

	constructor(
		protected httpClient: HttpClient,
		@Optional() configuration: Configuration
	) {
		if (configuration) {
			this.configuration = configuration;
			this.basePath ??= configuration.basePath;
		}
	}

	acceptRegulationUsingPATCH = (observe?: "body", reportProgress?: boolean): Observable<any> => this.httpClient.patch<any>(`${this.basePath}/api/v1/secure/showcase/accept-regulation`,
		null,
		{
			withCredentials: this.configuration.withCredentials,
			headers: this.defaultHeaders,
			observe,
			reportProgress
		}
	);

	showcaseFeedbackUsingPOST = (feedback: FeedbackDTO, idLot: number, observe?: "body", reportProgress?: boolean): Observable<number> => this.httpClient.post<number>(`${this.basePath}/api/v1/secure/showcase/feedback/${encodeURIComponent(String(idLot))}`,
		feedback,
		{
			withCredentials: this.configuration.withCredentials,
			headers: this.defaultHeaders,
			observe,
			reportProgress
		}
	);

	acceptedRegulationUsingGET = (observe?: "body", reportProgress?: boolean): Observable<boolean> => this.httpClient.get<boolean>(`${this.basePath}/api/v1/secure/showcase/accepted-regulation`,
		{
			withCredentials: this.configuration.withCredentials,
			headers: this.defaultHeaders,
			observe,
			reportProgress
		}
	);

	addToMyLotUsingPOST(idVehicles: number[], observe?: "body", reportProgress?: boolean): Observable<any> {
		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = ["application/json"],
			httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
		if (httpContentTypeSelected != undefined) {
			headers = headers.set("Content-Type", httpContentTypeSelected);
		}

		headers = headers.set(HeaderKey.NO_SUCCESS_POPUP, "true");
		return this.httpClient.post<any>(`${this.basePath}/api/v1/secure/showcase/add-to-myLot`,
			idVehicles,
			{
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe,
				reportProgress
			}
		);
	}

	searchVehiclesUsingGET(area?: string, brand?: string, licensePlate?: string, maxDamage?: number, maxMix?: number, maxPrice?: number, minDamage?: number, minMix?: number, minPrice?: number, model?: string, state?: string, vehicleCode?: number, frame?: string, observe?: "body", reportProgress?: boolean): Observable<VehicleShowcaseDTO[]> {
		let queryParameters = this.encoderParameters;

		if (area !== undefined && area !== null) {
			queryParameters = queryParameters.set("area", <any>area);
		}
		if (brand !== undefined && brand !== null) {
			queryParameters = queryParameters.set("brand", <any>brand);
		}
		if (licensePlate !== undefined && licensePlate !== null) {
			queryParameters = queryParameters.set("licensePlate", <any>licensePlate);
		}
		if (maxDamage !== undefined && maxDamage !== null) {
			queryParameters = queryParameters.set("maxDamage", <any>maxDamage);
		}
		if (maxMix !== undefined && maxMix !== null) {
			queryParameters = queryParameters.set("maxMix", <any>maxMix);
		}
		if (maxPrice !== undefined && maxPrice !== null) {
			queryParameters = queryParameters.set("maxPrice", <any>maxPrice);
		}
		if (minDamage !== undefined && minDamage !== null) {
			queryParameters = queryParameters.set("minDamage", <any>minDamage);
		}
		if (minMix !== undefined && minMix !== null) {
			queryParameters = queryParameters.set("minMix", <any>minMix);
		}
		if (minPrice !== undefined && minPrice !== null) {
			queryParameters = queryParameters.set("minPrice", <any>minPrice);
		}
		if (model !== undefined && model !== null) {
			queryParameters = queryParameters.set("model", <any>model);
		}
		if (state !== undefined && state !== null) {
			queryParameters = queryParameters.set("state", <any>state);
		}
		if (vehicleCode !== undefined && vehicleCode !== null) {
			queryParameters = queryParameters.set("vehicleCode", <any>vehicleCode);
		}
		if (frame !== undefined && frame !== null) {
			queryParameters = queryParameters.set("frame", <any>frame);
		}

		return this.httpClient.get<any>(`${this.basePath}/api/v1/secure/showcase/search-vehicles`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	bookMyLotUsingPATCH = (message: string, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.patch<any>(`${this.basePath}/api/v1/secure/showcase/book-myLot`,
			message,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	clickAndBuy = (idVehicle: number, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/secure/showcase/buy`,
			idVehicle,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	/* preemptVehicleUsingPATCH = (idVehicle: number, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.patch<any>(`${this.basePath}/api/v1/secure/showcase/preempt-vehicle`,
			idVehicle,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		); */

	createEditShowcaseUsingPOST = (showcaseDTO: ShowcaseDTO, observe?: "body", reportProgress?: boolean): Observable<any> =>
		this.httpClient.post<any>(`${this.basePath}/api/v1/secure/showcase`,
			showcaseDTO,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	getVehicleSold(offset: number, limit: number, sortOrder: string, sortField: string,
		idMarket: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (limit !== undefined && limit !== null) {
			queryParameters = queryParameters.set("limit", <any>limit);
		}
		if (offset !== undefined && offset !== null) {
			queryParameters = queryParameters.set("offset", <any>offset);
		}
		if (sortField !== undefined && sortField !== null) {
			queryParameters = queryParameters.set("sortField", <any>sortField);
		}
		if (sortOrder !== undefined && sortOrder !== null) {
			queryParameters = queryParameters.set("sortOrder", <any>sortOrder);
		}
		return this.httpClient.get<any>(`${this.basePath}/api/v1/secure/showcase/sold/${encodeURIComponent(String(idMarket))}`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getMyLotUsingGET = (observe?: "body", reportProgress?: boolean): Observable<MyLotFullDTO> =>
		this.httpClient.get<any>(`${this.basePath}/api/v1/secure/showcase/myLot`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	getShowcaseFullUsingGET(idMarket?: string, observe?: "body", reportProgress?: boolean): Observable<ShowcaseFullDTO> {
		let queryParameters = this.encoderParameters;

		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("idMarket", <any>idMarket);
		}

		return this.httpClient.get<ShowcaseFullDTO>(`${this.basePath}/api/v1/secure/showcase/showcase-full`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	isShowcaseOpenUsingGET = (observe?: "body", reportProgress?: boolean): Observable<boolean> =>
		this.httpClient.get<boolean>(`${this.basePath}/api/v1/secure/showcase/showcase-enabled`,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);

	getShowcaseUsingGET(idMarket?: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("idMarket", <any>idMarket);
		}

		return this.httpClient.get<any>(`${this.basePath}/api/v1/secure/showcase`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	removeToMyLotUsingDELETE(idVehicles: number[], observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (idVehicles) {
			idVehicles.forEach((element) => {
				queryParameters = queryParameters.append("idVehicles", <any>element);
			});
		}

		return this.httpClient.delete<any>(`${this.basePath}/api/v1/secure/showcase/remove-from-myLot`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}
}